import { render, staticRenderFns } from "./ModalShow.vue?vue&type=template&id=bd1a883e&scoped=true"
import script from "./ModalShow.vue?vue&type=script&lang=js"
export * from "./ModalShow.vue?vue&type=script&lang=js"
import style0 from "./ModalShow.vue?vue&type=style&index=0&id=bd1a883e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1a883e",
  null
  
)

export default component.exports